import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

/** @deprecated Use /create-guide/quick — unified Smart Create handles AI and quick upload. */
@Component({
  selector: "app-flowchest-ai-create-flow",
  template: "",
})
export class FlowchestAiCreateFlowComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(["/create-guide/quick"], { replaceUrl: true });
  }
}
